import { AlertType } from '~/types';
import { GENERIC_STATUS_ICON_COL, STANDARD_COLS } from '../genericTableColumns';
import { addBaseProperties, addLaunchReturn } from '../mappers';
import { ACTIVITY_TABLE_HEADERS } from './activities';
export const transformSafetyTether85 = (items) => {
    return items
        .map(addBaseProperties)
        .map(addLaunchReturn)
        .map((item) => {
        let rowClass = item.status?.evaReadiness?.alertType;
        rowClass = rowClass && rowClass === AlertType.ALERT ? 'red lighten-3' : '';
        const _item = Object.assign({}, item, { rowClass });
        return _item;
    });
};
// ex status => "No go for EVA"|"Requires Inspection"|"Go for EVA"
export const SAFETYTETHER85_TABLE_HEADERS = [...STANDARD_COLS];
export const ACTIVITY_SAFETY_TETHER_85_TABLE_HEADERS = [
    ...ACTIVITY_TABLE_HEADERS,
    GENERIC_STATUS_ICON_COL
];
